import { FirebaseError } from 'firebase/app';

export type FirestoreErrorCategory = 'permission-denied' | 'network' | 'unknown';

export const categorizeFirestoreError = (error: unknown): FirestoreErrorCategory => {
  if (error instanceof FirebaseError) {
    if (error.code === 'permission-denied') return 'permission-denied';
    if (error.code === 'unavailable' || error.code === 'deadline-exceeded') return 'network';
  }

  if (typeof error === 'object' && error && 'code' in error) {
    const code = String((error as { code?: unknown }).code);
    if (code.includes('permission-denied')) return 'permission-denied';
    if (code.includes('unavailable') || code.includes('deadline-exceeded')) return 'network';
  }

  if (error instanceof Error && /network/i.test(error.message)) {
    return 'network';
  }

  return 'unknown';
};
